import { PageShell, SIDEBAR_WIDTH_LABEL_ICONS } from '@heidi/design-system/page-shell';

import { MenuCoachmarkWelcome } from './coachmark';
import { AgentHomePanel } from './nav-v3';
import { SidebarPanel } from './sidebar-panel';
import { SideNav } from './SideNav';

interface ScribeNavigationProps {
  positioning: 'shell' | 'viewport';
  showPrimarySidebar: boolean;
  variant: 'sidebar' | 'inset';
  collapsible: 'icon' | 'label-icons';
  secondaryPanel: 'sidebar' | 'agent-home' | null;
}

/**
 * Owns the navigation positioning contract: rail, desktop header clearance,
 * and floating panel must use the same coordinate space. Callers select one
 * mode, not independent className/clearance overrides. Shared PageShell
 * defaults remain unchanged for other applications.
 */
export const ScribeNavigation = ({
  positioning,
  showPrimarySidebar,
  variant,
  collapsible,
  secondaryPanel,
}: ScribeNavigationProps) => {
  const isShellAnchored = positioning === 'shell';

  return (
    <>
      {showPrimarySidebar && (
        <PageShell.Sidebar
          variant={variant}
          collapsible={collapsible}
          withRail={collapsible === 'icon'}
          className={isShellAnchored ? 'absolute inset-y-0 h-auto' : undefined}
        >
          <SideNav isShellAnchored={isShellAnchored} />
        </PageShell.Sidebar>
      )}

      {secondaryPanel === 'agent-home' && <AgentHomePanel />}
      {secondaryPanel === 'sidebar' && (
        <MenuCoachmarkWelcome>
          <SidebarPanel
            primarySidebarWidth={SIDEBAR_WIDTH_LABEL_ICONS}
            isShellAnchored={isShellAnchored}
          />
        </MenuCoachmarkWelcome>
      )}
    </>
  );
};
